import { dateUtils } from '../common'

const PRODUCT_IDENT = Symbol('PRODUCT_IDENT') //                      产品标识
const BATCHNUMBER = Symbol('BATCHNUMBER') //                          批号
const SERIAL_NUMBER = Symbol('SERIAL_NUMBER') //                      原厂序列号
const PERIOD_BEGIN = Symbol('PERIOD_BEGIN') //                        生产日期
const PERIOD_EXPIRE = Symbol('PERIOD_EXPIRE') //                      失效日期
const PERIOD_END = Symbol('PERIOD_END') //                            过期时间
const ITEMS_QUANTITY = Symbol('ITEMS_QUANTITY') //                    数量
const QTY_FLAG_LOT_DEFAULT = Symbol('QTY_FLAG_LOT_DEFAULT') //        过期时间(MMYY)和批号
const QTY_FLAG_LOT_2 = Symbol('QTY_FLAG_LOT_2') //                    过期时间(MMDDYY)和批号
const QTY_FLAG_LOT_3 = Symbol('QTY_FLAG_LOT_3') //                    过期时间(YYMMDD)和批号
const QTY_FLAG_LOT_4 = Symbol('QTY_FLAG_LOT_4') //                    过期时间(YYMMDDHH)和批号
const QTY_FLAG_LOT_5 = Symbol('QTY_FLAG_LOT_5') //                    过期时间(YYJJJ)和批号
const QTY_FLAG_LOT_6 = Symbol('QTY_FLAG_LOT_6') //                    过期时间(YYJJJHH)和批号
const QTY_FLAG_SERIAL = Symbol('QTY_FLAG_SERIAL') //                  序列号
const QTY_FLAG_SERIAL_DEFAULT = Symbol('QTY_FLAG_SERIAL_DEFAULT') //  过期时间(MMYY)和序列号
const QTY_FLAG_SERIAL_2 = Symbol('QTY_FLAG_SERIAL_2') //              过期时间(MMDDYY)和序列号
const QTY_FLAG_SERIAL_3 = Symbol('QTY_FLAG_SERIAL_3') //              过期时间(YYMMDD)和序列号
const QTY_FLAG_SERIAL_4 = Symbol('QTY_FLAG_SERIAL_4') //              过期时间(YYMMDDHH)和序列号
const QTY_FLAG_SERIAL_5 = Symbol('QTY_FLAG_SERIAL_5') //              过期时间(YYJJJ)和序列号
const QTY_FLAG_SERIAL_6 = Symbol('QTY_FLAG_SERIAL_6') //              过期时间(YYJJJHH)和序列号

// 正则
const regs = {}
regs[PRODUCT_IDENT] = /(?<=\+A).+?(?=\/)/
regs[BATCHNUMBER] = /(?<=\/\$(|\$7))(?!(\+|\$)).*?(?=\/|$)/
regs[SERIAL_NUMBER] = /(?<=\/S).*?(?=\/|$)/
regs[PERIOD_BEGIN] = /(?<=\/16D).*?(?=\/|$)/
regs[PERIOD_EXPIRE] = /(?<=\/14D).*?(?=\/|$)/
regs[PERIOD_END] = /(?<=\/?!(\${1,2}|\+?|\/S|\/16D|\/14D|\/Q)).+?(?=\/|$)/
regs[ITEMS_QUANTITY] = /(?<=\/Q).*?(?=\/|$)/
//
regs[QTY_FLAG_LOT_DEFAULT] = /(?<=\/\${2}(?!(\+|[2-7]))).*?(?=\/|$)/
regs[QTY_FLAG_LOT_2] = /(?<=\/\${2}2).*?(?=\/|$)/
regs[QTY_FLAG_LOT_3] = /(?<=\/\${2}3).*?(?=\/|$)/
regs[QTY_FLAG_LOT_4] = /(?<=\/\${2}4).*?(?=\/|$)/
regs[QTY_FLAG_LOT_5] = /(?<=\/\${2}5).*?(?=\/|$)/
regs[QTY_FLAG_LOT_6] = /(?<=\/\${2}6).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL] = /(?<=\/(\${2}\+7|\${1}\+))(?![2-7]).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_DEFAULT] = /(?<=\/\${2}\+(?![2-7])).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_2] = /(?<=\/\${2}\+2).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_3] = /(?<=\/\${2}\+3).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_4] = /(?<=\/\${2}\+4).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_5] = /(?<=\/\${2}\+5).*?(?=\/|$)/
regs[QTY_FLAG_SERIAL_6] = /(?<=\/\${2}\+6).*?(?=\/|$)/

/**
 * 解析 HIBC 码类
 *
 * @class AnalysisHibcCode
 * @param {string} [code=""] 待解析 HIBC 码
 *
 */
export default class AnalysisHibcCode {
  constructor(code = '') {
    if (!new RegExp('^\\+', 'i').test(code)) throw new Error('请输入正确的 HIBC 码！')
    if (!this.m) this.m = new Map()

    // 待解析的 HIBC 码
    this.code = this.preprocess(code)
    //
    this.analysis()
  }

  // 预处理待解析 code
  preprocess(code) {
    console.log('待预处理 code: ', code)
    let newCode = ''
    const _code = `${code}`.toUpperCase() // 优化#31648，否则按大写键后可能无法识别
    const isA = /^\+A.*?/.test(_code) // 是否是 +A开头的数据 eg. +Axxx...xxc
    const isStandard = /^\+A.*?\//.test(_code) // 是否是标准格式数据 eg. +Axxxxx/xxxxxc

    if (isA) {
      // 如果是标准格式去掉 1 位校验位，否则不用去掉
      newCode = isStandard ? _code.substring(0, _code.length - 1) : _code
    } else {
      newCode = `${_code}`
        // 如果是分段数据，则替换 + 为 /
        .replace(/^\+/, '/')
        // 去掉 1 位连接符和 1 位校验位
        .substring(0, _code.length - 2)
    }

    console.log('预处理后 code: ', newCode)
    return newCode
  }

  // 解析
  analysis() {
    this.analysisProductCode()
    this.analysisCode(PERIOD_BEGIN)
    this.analysisCode(PERIOD_EXPIRE)
    this.analysisCode(ITEMS_QUANTITY)
    // 过期时间
    this.analaysisEndTime()
    // 批号
    this.analysisCode(BATCHNUMBER)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_DEFAULT)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_2)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_3)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_4)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_5)
    this.analaysisEndTimeAndLot(QTY_FLAG_LOT_6)
    // 序列号
    this.analysisCode(QTY_FLAG_SERIAL)
    this.analysisCode(SERIAL_NUMBER)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_DEFAULT)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_2)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_3)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_4)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_5)
    this.analaysisEndTimeAndSerial(QTY_FLAG_SERIAL_6)
  }

  /* 解析 */
  // 解析产品标识
  analysisProductCode() {
    const ret = this.code.match(regs[PRODUCT_IDENT])
    this.m.set(PRODUCT_IDENT, ret ? ret[0] : '')
  }

  // 解析批号、原厂序列号、生产日期、失效日期和数量
  analysisCode(code = BATCHNUMBER) {
    const tmp = this.code.match(regs[code])
    let ret = tmp ? tmp[0] : ''

    // 生产日期、失效日期格式化
    const codes = [PERIOD_BEGIN, PERIOD_EXPIRE]
    if (ret && codes.includes(code)) {
      ret = dateUtils.formatHibcDate(ret, 'YYYY-MM-DD')
    }
    if (ret && [PERIOD_EXPIRE].includes(code)) {
      ret = dateUtils.formatHibcDate(ret, 'YY-MM-DD')
    }
    if (ret) {
      this.m.set(code !== QTY_FLAG_SERIAL ? code : SERIAL_NUMBER, ret)
    }
  }

  // 解析过期时间
  analaysisEndTime() {
    const tmp = this.code.match(regs[PERIOD_END])
    let str = tmp ? tmp[0] : ''
    let group = { code: '', format: 'YYJJJ' }

    if (str) {
      this.m.set(PERIOD_END, dateUtils.formatHibcDate(str, group.format, group.separate))
    }
  }

  // 解析过期时间、批号
  analaysisEndTimeAndLot(code) {
    const tmp = this.code.match(regs[code])
    let str = tmp ? tmp[0] : ''
    let group = { code: '' }

    // +$$
    if ([QTY_FLAG_LOT_DEFAULT].includes(code)) {
      group.code = /(^\d{4})(.*)/
      group.format = 'MMYY'
    }
    // +$$2 or +$$3
    if ([QTY_FLAG_LOT_2, QTY_FLAG_LOT_3].includes(code)) {
      group.code = /(^\d{6})(.*)/
      group.format = code === QTY_FLAG_LOT_2 ? 'MMDDYY' : 'YYMMDD'
    }
    // +$$4
    if ([QTY_FLAG_LOT_4].includes(code)) {
      group.code = /(^\d{8})(.*)/
      group.format = 'YYMMDDHH'
    }
    // +$$5
    if ([QTY_FLAG_LOT_5].includes(code)) {
      group.code = /(^\d{5})(.*)/
      group.format = 'YYJJJ'
    }
    // +$$6
    if ([QTY_FLAG_LOT_6].includes(code)) {
      group.code = /(^\d{7})(.*)/
      group.format = 'YYJJJHH'
    }

    if (str && group.code) {
      this.m.set(
        PERIOD_END,
        dateUtils.formatHibcDate(str.replace(group.code, '$1'), group.format, group.separate)
      )
      this.m.set(BATCHNUMBER, str.replace(group.code, '$2'))
    }
  }

  // 解析过期时间、原厂序列号
  analaysisEndTimeAndSerial(code) {
    const tmp = this.code.match(regs[code])
    let str = tmp ? tmp[0] : ''
    let group = { code: '' }

    // +$$
    if ([QTY_FLAG_SERIAL_DEFAULT].includes(code)) {
      group.code = /(^\d{4})(.*)/
      group.format = 'MMYY'
    }
    // +$$+2 or +$$+3
    if ([QTY_FLAG_SERIAL_2, QTY_FLAG_SERIAL_3].includes(code)) {
      group.code = /(^\d{6})(.*)/
      group.format = code === QTY_FLAG_SERIAL_2 ? 'MMDDYY' : 'YYMMDD'
    }
    // +$$+4
    if ([QTY_FLAG_SERIAL_4].includes(code)) {
      group.code = /(^\d{8})(.*)/
      group.format = 'YYMMDDHH'
    }
    // +$$+5
    if ([QTY_FLAG_SERIAL_5].includes(code)) {
      group.code = /(^\d{5})(.*)/
      group.format = 'YYJJJ'
    }
    // +$$+6
    if ([QTY_FLAG_SERIAL_6].includes(code)) {
      group.code = /(^\d{7})(.*)/
      group.format = 'YYJJJHH'
    }

    if (str && group.code) {
      this.m.set(
        PERIOD_END,
        dateUtils.formatHibcDate(str.replace(group.code, '$1'), group.format, group.separate)
      )
      this.m.set(SERIAL_NUMBER, str.replace(group.code, '$2'))
    }
  }

  // 返回 Map
  map() {
    return {
      productIdent: { label: '产品标识', value: this.m.get(PRODUCT_IDENT) || null },
      batchNumber: { label: '批号', value: this.m.get(BATCHNUMBER) || null },
      serialNumber: { label: '原厂序列号', value: this.m.get(SERIAL_NUMBER) || null },
      periodBegin: { label: '生产日期', value: this.m.get(PERIOD_BEGIN) || null },
      periodEnd: { label: '有效期', value: this.m.get(PERIOD_END) || null },
      periodExpire: { label: '失效日期', value: this.m.get(PERIOD_EXPIRE) || null },
      amount: { label: '可变数量', value: this.m.get(ITEMS_QUANTITY) || null },
    }
  }
}
